import { graphql } from 'gatsby';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { StyledLanguagesGridBlockV3Section, StyledContainer } from './LanguagesGridBlockV3.styles';
import { type BlockHTMLId } from '@/utils/renderBlock';
import LanguagesGridBlockV3Item from './components/LanguagesGridBlockV3Item/LanguagesGridBlockV3Item';

interface LanguagesGridBlockV3Props extends Queries.LANGUAGES_GRID_BLOCK_V3Fragment {
  className?: string;
}

const LanguagesGridBlockV3 = ({
  languagesGridBlockV3Elements: elements,
  system,
  id,
  className,
}: LanguagesGridBlockV3Props & BlockHTMLId) => {
  if (!elements) {
    return null;
  }

  const icons = elements.icons?.value || [];

  if (icons.length === 0) {
    return null;
  }

  return (
    <StyledLanguagesGridBlockV3Section
      css={applyPaddingCSS(elements)}
      data-codename={system.codename}
      id={id}
      className={className}
    >
      <StyledContainer>
        {icons.map((icon) => (
          <LanguagesGridBlockV3Item key={icon.system.id} item={icon} />
        ))}
      </StyledContainer>
    </StyledLanguagesGridBlockV3Section>
  );
};

export default LanguagesGridBlockV3;

export const fragment = graphql`
  fragment LANGUAGES_GRID_BLOCK_V3 on kontent_item_languages_grid_block_v3 {
    system {
      id
      codename
      type
    }
    languagesGridBlockV3Elements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      icons {
        value {
          ...LANGUAGES_GRID_BLOCK_V3_ITEM
        }
      }
    }
  }
`;
